import { useSelector } from 'react-redux';
import { State } from '../store/combinedReducers';

export const useCurrentUser = () => useSelector((state: State) => state.general.loggedUser);
